module.exports = {"title":"One last thing...","hint":"Please click the below checkbox"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/recaptcha.json
// module id = 665
// module chunks = 247 1435